import { Module } from 'vuex';
import { ProductVersionState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: ProductVersionState = {
    list: undefined,
    index: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

const namespaced: boolean = true;

export const productVersion: Module<ProductVersionState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
